/**
 * Root Zone Water Potential Component
 * Displays current water potential with start date
 */

const React = require('react');
const { useTranslation } = require('react-i18next');
const PropTypes = require('prop-types');
const dayjs = require('../../../utils/dayjsConfig');
require('./RootZoneWP.css');

/**
 * RootZoneWP component
 * @param {Object} props
 * @param {number} props.value - Water potential value
 * @param {number} props.startDate - Unix timestamp
 * @param {string} props.unit - Unit of measurement
 */
const RootZoneWP = ({ value, startDate, unit }) => {
  const { t } = useTranslation();
  if (value === null || value === undefined) {
    return (
      <div className='root-zone-wp root-zone-wp--empty'>
        <span
          className='text-style-short-lables-14-regular'
          style={{ color: 'var(--color-grey-71)' }}
        >
          {t('no_data')}
        </span>
      </div>
    );
  }

  const formattedValue = value.toFixed(1);
  const formattedDate = startDate
    ? dayjs.unix(startDate).format('MMM D, h:mma')
    : 'N/A';

  return (
    <div className='root-zone-wp'>
      <div className='root-zone-wp__header'>
        <span
          className='text-style-short-lables-12-semi-bold'
          style={{ color: 'var(--color-grey-45)' }}
        >
          {t('root_zone_wp')}
        </span>
      </div>

      <div className='root-zone-wp__value'>
        <span
          className='text-style-short-lables-16-semi-bold'
          style={{ color: 'var(--color-grey-34)' }}
        >
          {formattedValue} {unit}
        </span>
      </div>

      <div className='root-zone-wp__date'>
        <span
          className='text-style-short-lables-12-regular'
          style={{ color: 'var(--color-grey-71)' }}
        >
          {t('since_date', { date: formattedDate })}
        </span>
      </div>
    </div>
  );
};

RootZoneWP.propTypes = {
  value: PropTypes.number,
  startDate: PropTypes.number,
  unit: PropTypes.string,
};

RootZoneWP.defaultProps = {
  value: null,
  startDate: null,
  unit: 'kPa',
};

module.exports = RootZoneWP;
